export enum UserType {
  Student = 'student',
  Business = 'business',
  Researcher = 'researcher',
  Author = 'author',
  Professional = 'professional',
}
